import React from "react";
import { Link } from "react-router-dom";
import "../style/Product.css"; 
import LeaveMessage from "./LeaveMessage";


const Solution = () => {
  return (
    <>
    <LeaveMessage />
    <div className="product-page solution-page">
      <h1>Solutions</h1>
      <div className="product-grid solution-grid">
        
        <Link to="/solution/indoor" className="product-card solution-card">
          <img src="/indoor/i1.jpg"></img>
          <h3>Indoor Shading Solution</h3>
          <p>Perfect for homes, offices, and indoor spaces.</p>
          <button className="product-btns">View More</button>
        </Link>

        <Link to="/solution/outdoor" className="product-card solution-card">
          <img src="/indoor/i1.jpg"></img>
          <h3><strong>Outdoor Shading Solution</strong></h3>
          <p>Durable and stylish options for outdoor areas.</p>
          <button className="product-btns">View More</button>
        </Link>
      </div>
    </div>
    </>
  );
};

export default Solution;
